import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { ReportTypeCreateStore } from "../../store";
import { InputString } from "../../../common/controls";
import { InputText } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type ReportTypeCreateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  nameSelectedValue?: { displayId: string; id: string } | null;
  onNameChange?: (value: string) => void;
  name: string;
  nameError?: string;
  descriptionSelectedValue?: { displayId: string; id: string } | null;
  onDescriptionChange?: (value: string) => void;
  description: string;
  descriptionError?: string;
  reportTypeCreateStore: ReportTypeCreateStore;
};

export const ReportTypeCreateForm: React.FC<ReportTypeCreateFormProps> =
  observer(
    ({
      onSave = () => {},
      onCancel = () => {},
      saving = false,
      showToolbox = true,
      showSaveFooter,
      name = "",
      nameError,
      onNameChange = () => {},
      description = "",
      descriptionError,
      onDescriptionChange = () => {},
      reportTypeCreateStore,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              saveAndCloseLabel={langStore.saveEntity}
              closeLabel={langStore.cancelNewEntity}
              saveForm={() => onSave()}
              saveDisabled={saving}
              closeForm={() => onCancel()}
            />
          )}
          <Box>
            <FormExtras
              entity="ReportType"
              mode="create"
              values={{}}
              options={{}}
              onPatch={(campo: string, valor: any) => {
                switch (campo) {
                  case "name":
                    onNameChange?.(valor);
                    break;
                  case "description":
                    onDescriptionChange?.(valor);
                    break;
                }
              }}
            />
            <GroupContainer
              id="null"
              errorText={reportTypeCreateStore.getCardErrors("null")}
              title={langStore.groupReportTypeLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <InputString
                  autoFocus
                  value={name}
                  error={Boolean(nameError)}
                  warning={
                    !nameError &&
                    Boolean(reportTypeCreateStore.warnings["name"])
                  }
                  helperText={
                    nameError || reportTypeCreateStore.warnings["name"]?.message
                  }
                  label={langStore.ReportTypeNameLabel}
                  onChange={(value: string) => onNameChange(value)}
                  description={langStore.ReportTypeNameDescription}
                />

                <InputText
                  value={description}
                  error={Boolean(descriptionError)}
                  warning={
                    !descriptionError &&
                    Boolean(reportTypeCreateStore.warnings["description"])
                  }
                  helperText={
                    descriptionError ||
                    reportTypeCreateStore.warnings["description"]?.message
                  }
                  label={langStore.ReportTypeDescriptionLabel}
                  onChange={(value: string) => onDescriptionChange(value)}
                  nullText={langStore.optionalFieldHint}
                  description={langStore.ReportTypeDescriptionDescription}
                />
              </FormControl>
            </GroupContainer>
          </Box>
          {(showSaveFooter ?? !showToolbox) && (
            <FormSaveFooter
              onSave={() => onSave()}
              label={langStore.saveEntity}
              disabled={saving}
            />
          )}
        </Grid>
      );
    }
  );
